import { render, staticRenderFns } from "./VmList.vue?vue&type=template&id=b8fe6c08"
import script from "./VmList.vue?vue&type=script&lang=js"
export * from "./VmList.vue?vue&type=script&lang=js"
import style0 from "./VmList.vue?vue&type=style&index=0&id=b8fe6c08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports